module.exports = __webpack_public_path__ + "img/32.384155fc.jpg";